<template>
    <Dialog
        v-if="emailLog"
        :value="true"
        :header-text="emailLog ? emailLog.msg.Subject : $t('Email')"
        hide-footer
        persistent
        full-content-width
        :width="700"
        @close_modal="$emit('close')"
    >
        <v-container class="py-0 px-6 pb-10">
            <div
                v-if="emailLog.status !== 'sent'"
                class="rounded d-flex px-4 py-3 align-center mb-8 error lighten-2"
            >
                <div
                    style="border-radius: 100%; min-width: 36px; min-height: 36px"
                    class="d-flex justify-center align-center mr-4 error"
                >
                    <icon
                        icon="Mail"
                        size="22"
                        color="white"
                    />
                </div>
                <div>
                    <div class="d-flex align-center mb-1">
                        <icon
                            size="18"
                            color="error"
                            icon="AlertTriangle"
                        />
                        <div class="ml-2 subtitle-1 error--text">
                            {{ emailLog.status === 'failed' ? $t('Email not delivered') : $t('Sent, but fallback to Uku email') }}
                        </div>
                    </div>
                    <div class="body-2">
                        {{ emailLog.fail_message ? emailLog.fail_message : $t('Unknown error') }}
                    </div>
                </div>

            </div>
            <div class="d-flex">
                <div class="body-2 font-weight-medium">
                    {{ emailLog.msg.From }}
                </div>
                <div class="body-2 ml-auto g4--text">
                    {{ formatDateTime(emailLog.sent_at) }}
                </div>
            </div>
            <div class="body-2 g4--text mb-4">
                {{ $t('to') }} {{ emailLog.msg.To }}
                <EmailDetails :email-log="emailLog" />
            </div>
            <div class="body-2 email-content" v-html="emailLog.msg.Content" /> <!-- INPUT CLEANED WHEN SAVING -->
        </v-container>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog.vue";
import { $t } from "@/i18n";
import EmailDetails from "@/views/Client/Communication/History/EmailDetails";
import {onMounted, ref} from "@vue/composition-api";
import ApiClientCommunication from "@/api/client/communication"
import errorDialog from "@/views/ErrorDialog/errorDialog";
import { formatDateTime } from "@/plugins/formatting"

export default {
    name: "EmailLogDialog",
    components: {
        Dialog,
        EmailDetails
    },
    props: {
        emailLogId: {
            type: Number,
            required: true
        },
        clientId: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const emailLog = ref(null);

        onMounted(async () => {
            try {
                const data = await ApiClientCommunication.getEmailLog(props.emailLogId)
                emailLog.value = data.email_log
            } catch (e) {
                errorDialog.showError(e)
            }
        })

        return {
            emailLog,
            formatDateTime
        };
    }
};
</script>